import { render, staticRenderFns } from "./AlertingOpsgenie.vue?vue&type=template&id=3acf2b46&scoped=true"
import script from "./AlertingOpsgenie.vue?vue&type=script&lang=js"
export * from "./AlertingOpsgenie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acf2b46",
  null
  
)

export default component.exports